module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-03.dfa07475.png";